import {Food} from "./types";

const PorkHub: Food = {
    "Boneless Pork Chops": {
        "Yellow Roasted Pots": "4.5oz",
        "Roasted Broccoli": "2.5",
        "Boneless Pork Chops": "4.5"
    },
    "Carnitas Fajita": {
        "Carnitas": "4.5oz",
        "Brown Rice": "5oz (WHITE scoop)",
        "Fajita Peppers & Onions": "2.5oz"
    },
    "Carnitas Burrito Bowl": {
        "Carnitas": "4.2 oz",
        "Burrito Rice": "4.5 oz \nOVERFILLED (WHITE Scoop)",
        "Mexican Cheese": "14g",
        "Garnish": "Corn",
        "Sides": "Pico de gallo and Chipotle Yogurt"
    }
}

export default PorkHub